<template>
    <svg width="17px" height="8px" viewBox="0 0 17 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Comps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Public-Profile---Edit" transform="translate(-603.000000, -1768.000000)" stroke="#FFFFFF">
                <polyline id="Path-6" points="604 1775.54019 611.54019 1768 619.08038 1775.54019"></polyline>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconUp"
};
</script>

